module.exports = __webpack_public_path__ + "static/safe-d46bad902d3c5a28ef9d21780e739384.png";